import axios from 'axios';
import * as actions from '../api';
import checkAccessToken from './checkAccessToken'
import { closeFlight } from "../departures";

const api = store => next => async action => {

  if (action.type !== actions.apiCallBegan.type) return next(action)

  const {base, url, method, data, auth, onStart, onSuccess, onError, onFollowUp, followUpData} = action.payload;
  const env = process.env.REACT_APP_ENVIRONMENT;

  if (onStart) store.dispatch({type: onStart});
  
  next(action)
  
  try {
    let token = store.getState().auth.fredAccessToken
    let tokenExpiration = store.getState().auth.fredTokenExpiration
    let refreshToken = store.getState().auth.fredRefreshToken
    let tempToken = await checkAccessToken(tokenExpiration, token, refreshToken, store)
    // NOTE // sets Authorization default for axios requests
    let defaultAuth = {'Authorization': `Bearer ${tempToken ? tempToken : token}`}
    let baseUrl;

    // NOTE // our api
    if (base === 'fred') {
      if (env === 'test') {
        baseUrl = 'https://fred-test.paxiq.com/api'
      }
      else if (env === 'production') {
        baseUrl = 'https://fred.paxiq.com/api'
      }
      else {
        baseUrl = 'http://localhost:9050/api/'
      }
    }

    // NOTE // amelia
    else if (env === 'production'){
      baseUrl = 'https://advancedair-api.intelisys.ca/RESTv1'
    }

    else {
      baseUrl = 'https://advancedair-api.intelisystraining.ca/RESTv1'
      // NOTE // prod-data: 'https://advancedair-api.intelisys.ca/RESTv1'
      // NOTE // training/default: 'https://advancedair-api.intelisystraining.ca/RESTv1'
      // NOTE // what they gave me: 'https://advanceair-api.intelisysuat.ca/RESTv1' (was for testing something can't remember what)
    }

    // NOTE // singular request
    if (typeof url == 'string') {
      if (url.includes('sendPaxItin')) {
        data.fredKey = tempToken ? tempToken : token
      }
      let response = await axios.request({
        baseURL: baseUrl,
        url,
        method,
        data,
        auth: auth ? auth : '',
        headers: auth ? '' : defaultAuth 
      })
      
      // General
      store.dispatch(actions.apiCallSuccess(response.data))
  
      // Specific
      if (onSuccess) store.dispatch({type: onSuccess, payload: response.data});
      if (onFollowUp) store.dispatch(onFollowUp.action)
    }
    // NOTE // multiple requests (should only need this for amelia update/post many)
    else if (Array.isArray(url)) {
      for (let i = 0; i < url.length; i++) {
        const curURL = url[i];
        let response = await axios.request({
          baseURL: baseUrl,
          url: curURL,
          method,
          data: data[i],
          auth: auth ? auth : '',
          headers: auth ? '' : defaultAuth 
        })

        if (onSuccess) store.dispatch({type: onSuccess, payload: response.data});
      }
      if (onFollowUp) {
        if (onFollowUp == 'closeFlight') {
          store.dispatch(closeFlight(followUpData.statusKey, followUpData.legKey, followUpData.output))
        } 
      }
    }
  } catch (err) {
    console.log(err)
    // General
    store.dispatch(actions.apiCallFailed(err.message));

    // Specific
    if (onError) store.dispatch({type: onError, payload: err.message});
  }
}

export default api;